import { render, staticRenderFns } from "./AccountHolderInvestment.vue?vue&type=template&id=35ca5811&scoped=true"
import script from "./AccountHolderInvestment.vue?vue&type=script&lang=ts"
export * from "./AccountHolderInvestment.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderInvestment.vue?vue&type=style&index=0&id=35ca5811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ca5811",
  null
  
)

export default component.exports